import styles from './BusyLoader.module.scss';

import cx from 'classnames';
import React from 'react';
import { msieVersion } from '../../utils/UserAgent';

export const BusyLoader: React.FC<React.AllHTMLAttributes<HTMLDivElement>> = ({ className, ...props }) => (
  <div
    className={cx(styles.wrapper, className, {
      [styles.wrapperIe11]: msieVersion && msieVersion <= 11,
    })}
    title="Loading"
    {...props}
  />
);
